import CatalogTrack from '@common/types/catalog/catalog-track';
import { Ownership } from '@services/ownership/types/ownership';
import { assetOwners } from '@webapp/store/ownership/selectors';
import { OwnershipState } from '@webapp/store/ownership/state';
import arrayMove from 'array-move';

export const getRoute = (
  releaseId: string,
  type: string,
  lock: string,
  track: CatalogTrack
) => {
  return (
    '/' +
    [
      'user-profile/change-split/track',
      releaseId,
      track.id,
      track.name,
      type,
      lock,
    ]
      .filter((f) => !!f)
      .join('/')
  );
};

export const checkOwnerId = (
  owners: OwnershipState,
  assetId: string,
  id: string
) => {
  return assetOwners(owners, assetId)
    .map((owner) => owner.ownerId)
    .includes(id);
};

export const updateOwnershipsWithSplit = (
  ownerships: Ownership[],
  isRequest: boolean,
  ownershipId: string,
  updatedSplit: number
) => {
  return ownerships.map((ownerShip) => {
    if (
      (ownerShip.id ||
        `${ownerShip.ownerType}#${ownerShip.ownershipType}#${ownerShip.ownerId}`) ===
      ownershipId
    ) {
      ownerShip.split = updatedSplit;
      if (!isRequest && ownerShip.requestedSplit) {
        ownerShip.requestedSplit = updatedSplit;
      }
    }
    return ownerShip;
  });
};

export const removeOwnershipFromArray = (
  ownerships: Ownership[],
  ownershipId: string
) => {
  return ownerships.filter(
    (ownerShip) =>
      (ownerShip.id ||
        `${ownerShip.ownerType}#${ownerShip.ownershipType}#${ownerShip.ownerId}`) !==
      ownershipId
  );
};

export const updateOwnershipIndex = (
  ownerships: Ownership[],
  oldIndex: number,
  newIndex: number
) => {
  let newOwners = arrayMove(ownerships, oldIndex, newIndex);
  newOwners = newOwners.map((owner, index) => {
    owner.order = index;
    return owner;
  });
  return newOwners;
};
